
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    },

    error: {
      type: Boolean,
      default: false
    },

    /**
     * @values icons
     */
    icon: {
      /** @type {AlturaIcons} */
      type: String,
      default: ''
    },

    title: {
      type: String,
      default: ''
    },

    subtitle: {
      type: String,
      default: ''
    },

    action: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      timeout: undefined,
      resolve: undefined,
      reject: undefined,

      internalValues: {
        show: false,
        title: '',
        subtitle: '',
        action: '',
        icon: '',
        error: false
      }
    };
  },

  mounted () {
    if (this.$el?.parentElement?.id !== 'toast-container') { this.getOrCreateToastContainer().appendChild(this.$el); }
  },

  methods: {
    getOrCreateToastContainer () {
      const existingContainer = document.getElementById('toast-container');

      if (existingContainer) { return existingContainer; }

      const container = document.createElement('div');
      container.id = 'toast-container';
      document.body.appendChild(container);
      return container;
    },
    triggerAction () {
      this.internalValues.show = false;

      if (this.resolve) { this.resolve(true); }

      if (this.timeout) {
        clearTimeout(this.timeout);
        return;
      }

      this.$emit('click');
    },

    open (options) {
      if (this.timeout) { clearTimeout(this.timeout); }

      let delay = 5000;

      this.internalValues.show = true;

      if (typeof options === 'string') {
        this.internalValues.error = false;
        this.internalValues.title = options;
        this.internalValues.subtitle = undefined;
        this.internalValues.action = undefined;
        this.internalValues.icon = undefined;
      } else {
        delay = options.delay ?? delay;
        this.internalValues.error = options.error;
        this.internalValues.title = options.title;
        this.internalValues.subtitle = options.subtitle;
        this.internalValues.action = options.action;
        this.internalValues.icon = options.icon;
      }

      if (delay > 0) {
        this.timeout = setTimeout(() => {
          this.internalValues.show = false;

          if (this.resolve) { this.resolve(false); }
        }, delay);
      }

      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    }
  }
};
